import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "skokovo-header" }
const _hoisted_2 = ["src"]

import skolkovoLogo from '@/assets/skolkovo-logo.svg'


export default /*#__PURE__*/_defineComponent({
  __name: 'SkolkovoHeader',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", { src: _unref(skolkovoLogo) }, null, 8, _hoisted_2)
  ]))
}
}

})